import { Picker } from 'antd-mobile';
import { appMethod as app, appInstance } from '@utils/app';
import utils from '@utils/util';
import ScratchClass from '@utils/scratch';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GpPaySuccess.less';

export default class GpPaySuccess extends OfficialPage {
  state = {
    page: 1,
    status: 0, // 0: 普通页面 1:有集集乐的情况
    orderId: '',
    modelId: '',
    franchiseeId: '',
    collectBenefitData: {}, // 集集乐数据
    starData: [], //集集乐的星 light:已集样式 dark:未集样式
    isFail: true, //刮刮乐未中奖
    isWinning: true, //刮刮乐中奖
    isComfort: true, //刮刮乐安慰奖
    isWhole: true, //刮奖区域是否显示
    scratchId: '', //活动号
    isShowteam: false,
    winingTitle: '',
    isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false,
    goodsData: {
      goods_list: [],
      is_more: 1,
      curpage: 1,
      loading: false,
      loadingFail: false
    },
    needNum: 0,
    formid: []
  }
  seckillFunc = []
  isMore = 1
  page = 1

  constructor(props) {
    super(props);
    document.title = '支付成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    if (options.collectBenefit == 1) {
      that.getCollectBenefitData(options.detail)
      that.setData({
        status: 1
      })
    }
    that.setData({
      team_token: options.teamToken,
      orderId: options.detail,
      franchiseeId: options.franchisee || '',
      is_group: options.is_group || '',
      code: options.code || '',
      is_newAppointment: options.is_newAppointment || ''
    })
    that.getOrderDetail()
    this.loadMyTeams()
    this.getAppECStoreConfig()
    that.getGoldenData(options.detail)
    let systemInfo = app.globalData.systemInfo || {}
    let width = (558 * systemInfo.windowWidth) / 750
    let height = (258 * systemInfo.windowWidth) / 750

    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            isShowteam: true
          })
        }, 10)
      }
    })
  }

  componentWillUnmount() {
    if (this.downcount) {
      this.downcount.clear()
    }
  }

  onReachBottom = () => {
    if (this.isMore) {
      this.loadList()
    }
  }
  loadList = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/goodsList',
      data: {
        page: _this.page,
        page_size: 4,
        status: 1,
        app_id: _this.data.appId,
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      success: res => {
        let rdata = res.data,
          newdata = {},
          compid = 'goodsData',
          goodsList = this.data.goodsData.goods_list,
          length = goodsList.length,
          downcountArr = _this.downcountArr || []
        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i]
          f.description = ''
          f.original_price =
            f.virtual_price == '0.00' ? f.original_price : f.virtual_price
        }
        var dataArr = res.data
        newdata[compid + '.goods_list'] = goodsList.concat(dataArr)
        newdata[compid + '.is_more'] = res.is_more
        newdata[compid + '.curpage'] = 1
        newdata[compid + '.loading'] = false
        newdata[compid + '.loadingFail'] = false
        _this.downcountArr = downcountArr
        _this.setData(newdata)
        _this.page++
        _this.isMore = res.is_more
      }
    })
  }
  loadMyTeams = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/teamInfo',
      data: {
        team_token: _this.data.team_token
      },
      success: res => {
        if (!res.data.order_info) {
          // 因微信接口有时会很慢，做了个递归处理
          setTimeout(() => {
            _this.loadMyTeams()
          }, 500)
          return
        }
        var coverList = [],
          myTeams = res.data,
          coverObj = {},
          orderInfo = myTeams.order_info || '',
          goodsDetail = orderInfo.goods_info[0],
          originPrice =
            goodsDetail.virtual_price == '0.00'
              ? goodsDetail.original_price
              : goodsDetail.virtual_price,
          modelId = myTeams.model_id || '',
          maxNum = Number(myTeams.max_user_num) || 0,
          needNum = maxNum - myTeams.current_user_count || '',
          originPrice =
            myTeams.virtual_price == '0.00'
              ? myTeams.goods_price
              : myTeams.virtual_price
        myTeams.downCount = {
          hours: '00',
          minutes: '00',
          seconds: '00',
          days: '00'
        }
        if (myTeams.member) {
          var coverTotalArr = myTeams.member || '',
            coverArr = [],
            numLack =
              myTeams.activity_type == 3
                ? maxNum - coverTotalArr.length + 1
                : maxNum - coverTotalArr.length,
            numLen = 0,
            coverLoading = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/loading-portrait.png'
            },
            coverUser = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png'
            },
            coverSuccess = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/success-loading.png'
            }
          for (let arrIndex in coverTotalArr) {
            coverObj = {
              isNum: 1,
              image: coverTotalArr[arrIndex]
            }
            coverArr.push(coverObj)
          }
          if (maxNum > 5) {
            switch (coverArr.length) {
              case 1:
                numLen = 2
                break
              case 2:
                numLen = 1
                break
              case 3:
                numLen = 0
                break
            }
            if (coverArr.length < 3) {
              //显示3个用户+1个等待+1个用户
              coverList = coverArr
              for (var i = 0; i < numLen; i++) {
                coverList.push(coverUser)
              }
              coverList.push(coverLoading)
              coverList.push(coverUser)
            } else if (coverArr.length >= 3 && coverArr.length < 5) {
              for (var index in coverArr) {
                if (index < 3) {
                  coverList.push(coverArr[index])
                }
              }
              coverList.push(coverLoading)
              coverList.push(coverUser)
            } else if (coverArr.length >= 5) {
              if (coverArr.length < maxNum) {
                for (var index in coverArr) {
                  if (index < 3) {
                    coverList.push(coverArr[index])
                  }
                }
                coverList.push(coverLoading)
                coverList.push(coverUser)
              } else {
                for (var index in coverArr) {
                  if (index < 4) {
                    coverList.push(coverArr[index])
                  }
                }
                coverList.push(coverSuccess)
              }
            }
          } else {
            coverList = coverArr
            for (let i = 0; i < numLack; i++) {
              coverList.push(coverUser)
            }
          }
        }
        myTeams.server_time = res.current_time
        myTeams.seckill_end_time = utils.formatTime(
          new Date(myTeams.expired_time * 1000)
        )
        if (myTeams.current_status == 0 || myTeams.current_status == 1) {
          _this.downcount = _this.beforeGroupDownCount(
            myTeams,
            _this,
            'myTeams'
          )
        } else if (myTeams.current_status == 2) {
          _this.downcount = _this.duringGroupDownCount(
            myTeams,
            _this,
            'myTeams'
          )
        }
        if (myTeams.parent_shop_app_id) {
          _this.setData({
            appId: myTeams.parent_shop_app_id,
            franchiseeId: myTeams.app_id
          })
        }
        _this.setData({
          originPrice: originPrice,
          myTeams: myTeams,
          modelId: modelId,
          goodsId: myTeams.goods_id,
          activityId: myTeams.activity_id,
          orderId: orderInfo.order_id,
          member: coverList,
          goodsDetail: orderInfo.goods_info[0],
          needNum: needNum
        })
        _this.loadList()
      }
    })
  }
  beforeGroupDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.status'] = 3
          newData[path + '.current_status'] = 3
          newData[path + '.server_time'] = formData.seckill_start_time
          page.setData(newData)
          formData.server_time = formData.seckill_start_time
          _this.downcount = _this.duringGroupDownCount(formData, page, path)
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  duringGroupDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.status'] = 4
          newData[path + '.current_status'] = 4
          page.setData(newData)
          if (path == 'myTeams') {
            page.loadMyTeams()
          }
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  touchStart = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchMove = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchEnd = e => {
    if (!this.isStart) return
    let { canvasWidth, canvasHeight, minX, minY, maxX, maxY } = this
    if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
      this.ctx.draw()
      this.endCallBack && this.endCallBack()
      this.isStart = false
      this.page.setData({
        isScroll: true
      })
    }
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        app_id: that.data.appId,
        sub_shop_app_id: that.data.franchiseeId || ''
      },
      success: function (data) {
        if (data.data) {
          if (that.data.code) {
            that.setData({
              isWhole: true
            })
          } else {
            that.setData({
              isWhole: false,
              scratchId: data.data
            })
          }
        } else {
          that.setData({
            isWhole: true
          })
        }
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  showAreaClick = () => {
    let that = this
    that.setData({
      isShowteam: false
    })
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        app_id: that.data.appId,
        sub_shop_app_id: that.data.franchiseeId || ''
      },
      success: function (res) {
        let data = res.data
        that.scratch.start()
        if (data.title == '谢谢参与') {
          that.setData({
            isFail: false
          })
        } else {
          let params = {
            ifWxCoupon: data.card_id || false,
            timestamp: data.timestamp || '',
            signature: data.signature || ''
          }
          if (data.is_comfort) {
            params['isComfort'] = false
          } else {
            params['isWinning'] = false
            params['winingTitle'] = data.title
          }
          that.setData(params)
        }
      }
    })
  }
  onShareAppMessage = res => {
    var that = this,
      goods = that.data.goodsDetail,
      myTeams = this.data.myTeams || {},
      team_token = (myTeams.order_info && myTeams.order_info.team_token),
      type = myTeams.activity_type,
      modelId = this.data.modelId,
      joined = myTeams.joined,
      franchiseeParam = this.data.franchiseeId
        ? '&franchisee=' + this.data.franchiseeId
        : '',
      share_path =
        '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' +
        team_token +
        '&orderId=' +
        that.data.orderId +
        franchiseeParam,
      share_cover = myTeams.share_cover
        ? myTeams.share_cover
        : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
      nickname = app.getUserInfo('nickname'),
      title = myTeams.share_title
        ? myTeams.share_title
        : (nickname ? nickname + ' 喊你' : '') +
        '拼单啦~ ' +
        (that.data.myTeams && that.data.myTeams.group_buy_price) +
        '元拼' +
        (that.data.myTeams && that.data.myTeams.goods_title) +
        '，火爆抢购中......'
    return {
      path: share_path,
      title: title,
      imageUrl: share_cover,
      success: function (res) {
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/getTime',
          data: {
            activity_id: that.data.scratchId,
            type: 'share',
            app_id: that.data.appId,
            sub_shop_app_id: that.data.franchiseeId || ''
          },
          success: function (res) { }
        })
      },
      fail: function (res) { }
    }
  }
  getCollectBenefitData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
      data: {
        order_id: id,
        app_id: that.data.appId,
        sub_shop_app_id: that.data.franchiseeId || ''
      },
      hideLoading: true,
      success: function (res) {
        let starData = []
        for (var i = 0; i < res.data.star_num; i++) {
          starData.push('light')
        }
        for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
          starData.push('dark')
        }
        that.setData({
          collectBenefitData: res.data,
          starData: starData
        })
      }
    })
  }
  showMyTeam = () => {
    let path =
      '/group/pages/gpmyOrder/gpmyOrder' +
      (this.data.franchiseeId ? '?franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(path, 1)
    })
  }
  openNewGroup = () => {
    let myTeams = this.data.myTeams
    if (myTeams.enable_status == '0') {
      app.turnToPage(
        '/pages/goodsDetail/goodsDetail?detail=' +
        myTeams.goods_id +
        (this.data.franchiseeId
          ? '&franchisee=' + this.data.franchiseeId
          : '')
      )
      return
    }
    var pathUrl =
      '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
      this.data.myTeams.goods_id +
      '&activity_id=' +
      this.data.myTeams.activity_id +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pathUrl)
    })
  }
  goToHomepage = () => {
    let router = app.getHomepageRouter()
    app.reLaunch({
      url: '/pages/' + router + '/' + router
    })
  }
  gotoDetail = e => {
    var _this = this,
      data = e.currentTarget.dataset,
      pageUrl =
        '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
        data.goodsid +
        '&activity_id=' +
        data.activityid +
        (_this.data.franchiseeId
          ? '&franchisee=' + _this.data.franchiseeId
          : '')
    this.saveUserFormId(function () {
      app.turnToPage(pageUrl)
    })
  }
  goToOrderDetail = () => {
    let that = this
    let groupPath =
      '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let pagePath =
      '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let appointmentPath =
      '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    let newAppointmentPath =
      '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    that.saveUserFormId(function () {
      if (this.data.is_group == 'true') {
        app.turnToPage(groupPath, true)
      } else if (this.data.code) {
        app.turnToPage(appointmentPath, true)
      } else if (this.data.is_newAppointment) {
        app.turnToPage(newAppointmentPath, true)
      } else {
        app.turnToPage(pagePath, true)
      }
    })
  }
  goToGroupDetail = () => {
    var pageUrl =
      '/group/pages/gporderDetail/gporderDetail?from=paySuccess' +
      '&teamtoken=' +
      this.data.myTeams.order_info.team_token +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pageUrl)
    })
  }
  getOrderDetail = () => {
    var _this = this
    app.getOrderDetail({
      data: {
        order_id: _this.data.orderId,
        app_id: _this.data.appId,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.setData({
          orderInfo: res.data[0].form_data
        })
      }
    })
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            app_id: _this.data.appId,
            sub_shop_app_id: _data.franchiseeId || '',
            activity_id: _data.scratchId
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
          }
        })
      }
    })
  }
  turnToGoodsDetail = () => {
    var pageUrl =
      '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
      this.data.myTeams.goods_id +
      '&activity_id=' +
      this.data.myTeams.activity_id +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pageUrl)
    })
  }
  inviteFriends = () => {
    let that = this
    let myTeams = this.data.myTeams
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/getShareQRCode',
      data: {
        goods_id: myTeams.goods_id,
        activity_id: myTeams.activity_id,
        app_id: that.data.appId,
        sub_shop_app_id: that.data.franchiseeId || '',
        type: 6,
        text: myTeams.goods_title,
        price: myTeams.group_buy_price,
        virtual_price: that.data.originPrice,
        goods_img: myTeams.img_urls ? myTeams.img_urls[0] : myTeams.goods_cover,
        sub_shop_id: that.data.franchiseeId,
        user_token: app.globalData.PromotionUserToken || '',
        team_token: myTeams.order_info.team_token,
        order_id: myTeams.order_info.order_id
      },
      success: function (res) {
        // animation.bottom('0').step()
        // that.setData({
        //   'pageQRCodeData.shareDialogShow': 0,
        //   'pageQRCodeData.shareMenuShow': true,
        //   'pageQRCodeData.goodsInfo': res.data,
        //   'pageQRCodeData.animation': animation.export()
        // })
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data,
          },
        });
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.data.franchiseeId)
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        app_id: _this.data.appId,
        sub_shop_app_id: _this.data.franchiseeId || '',
        form_id: _this.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      pageQRCodeData,
      myTeams,
      goodsDetail,
      originPrice,
      goodsInfo,
      needNum,
      member,
      collectBenefitData,
      starData,
      status,
      isWhole,
      isFail,
      isWinning,
      winingTitle,
      isComfort,
      ifGetComfort,
      ifWxCoupon,
      hideCanvas,
      scratch,
      isScroll,
      isShowteam,
      ifUserInfo,
      userInfo,
      userInfoCollectConfig,
      isGetPhoneNumber,
      todayDate,
      userCityArr,
      vipCardInfo,
      isShowVipCardDialog,
      orderId,
      franchisee,
      goodsData
    } = this.state

    return (
      <div className="official-page gp-pay-success">
        <TopNav title="支付成功" />
        <div className="collage-paySuccess">
          <div
            className="collage-section collage-goods"
            style={convertLineStyleData(
              'background:url(' +
              ((myTeams && myTeams.activity_info && myTeams.activity_info.pay_success_img) ||
                'https://img.zhichiwangluo.com/zcimgdir/album/file_5c35b5412bd8d.jpg') +
              ') no-repeat top;background-size:100%;'
            )}
          >
            <div
              className="goods-infor  isRelative"
              onClick={this.turnToGoodsDetail}
            >
              <div className="goods-detail">
                <div className="image-wrap">
                  <img src={myTeams && myTeams.goods_cover} />
                </div>
                <div className="content-wrap">
                  <div className="title">
                    <div className="classify-type">
                      <div>
                        <i className="ico-moon icon-number-people"></i>
                      </div>
                      <span>
                        {(myTeams && myTeams.activity_type == 0)
                          ? myTeams.max_user_num + '人团'
                          : (myTeams && myTeams.activity_type == 1)
                            ? '新人团'
                            : (myTeams && myTeams.activity_type == 2)
                              ? '阶梯团'
                              : (myTeams && myTeams.activity_type == 3)
                                ? '帮帮团'
                                : '抽奖团'}
                      </span>
                    </div>
                    {goodsDetail && goodsDetail.goods_name}
                  </div>
                  <div className="price">
                    <label className="min-price">
                      ¥<span>{myTeams && myTeams.group_buy_price}</span>
                    </label>
                    <span className="origin-price">{'¥' + originPrice}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="collage-section collage-infor">
              {(myTeams && myTeams.activity_type != 4) ? (
                <React.Fragment>
                  {myTeams.current_status == 2 && (
                    <div className="loading-stand">
                      <div className="tip">
                        <div>
                          {myTeams.activity_type != '2' ? (
                            <React.Fragment>
                              还差
                              <span className="needNum">{needNum + '人'}</span>
                              拼购成功, 剩余
                            </React.Fragment>
                          ) : (
                              <React.Fragment>人数越多, 价格越低, 剩余</React.Fragment>
                            )}
                        </div>
                        <div className="countDown">
                          {(myTeams.downCount.days != '00' ||
                            myTeams.downCount.days != '0') && (
                              <React.Fragment>
                                <span>{myTeams.downCount.days}</span>
                                <span>天</span>
                              </React.Fragment>
                            )}
                          <span>{myTeams.downCount.hours}</span>
                          <span>:</span>
                          <span style={convertLineStyleData('width:48rpx;')}>
                            {myTeams.downCount.minutes}
                          </span>
                          <span>:</span>
                          <span style={convertLineStyleData('width:48rpx;')}>
                            {myTeams.downCount.seconds}
                          </span>
                        </div>
                      </div>
                      <div className="member-cover">
                        {member.map((item, index) => {
                          return (
                            <div key={index}>
                              <img
                                src={item.image}
                                style={convertLineStyleData(
                                  'border: ' +
                                  (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                                )}
                              />
                              {index == 0 && (
                                <div className="leader-logo">团长</div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                      <div className="btn-wrap">
                        <div
                          className="open-new isRelative"
                          onClick={this.inviteFriends}
                        >
                          邀请好友参团
                        </div>
                        <div
                          className="show-own isRelative"
                          onClick={this.showMyTeam}
                        >
                          查看我的拼团
                        </div>
                      </div>
                    </div>
                  )}
                  {myTeams.current_status == 3 && (
                    <div className="success-stand">
                      <div className="tip">
                        {myTeams.activity_type == 3 ? (
                          <React.Fragment>
                            <span style={convertLineStyleData('color:#ff7100;')}>拼团成功，</span>
                            商家将给团长发货
                          </React.Fragment>
                        ) : (
                            <React.Fragment>
                              <span style={convertLineStyleData('color:#ff7100;')}>拼购成功，</span>
                              请耐心等待商家发货
                          </React.Fragment>
                          )}
                      </div>
                      <div className="member-cover">
                        {member.map((item, index) => {
                          return (
                            <div key={index}>
                              <img
                                src={item.image}
                                style={convertLineStyleData(
                                  'border: ' +
                                  (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                                )}
                              />
                              {index == 0 && (
                                <div className="leader-logo">团长</div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                      <div className="btn-wrap">
                        <div
                          className="open-new isRelative"
                          onClick={this.openNewGroup}
                        >
                          开启新团
                        </div>
                        <div
                          className="show-own isRelative"
                          onClick={this.showMyTeam}
                        >
                          查看我的拼团
                        </div>
                      </div>
                    </div>
                  )}
                  {(myTeams.current_status == 4 ||
                    myTeams.current_status == 5) && (
                      <div className="fail-stand">
                        <div className="tip">
                          <div>
                            超过时限,<span style={convertLineStyleData('color:#ff7100;')}>团已过期</span>
                          </div>
                        </div>
                        <div className="member-cover">
                          {member.map((item, index) => {
                            return (
                              <div key={index}>
                                <img
                                  src={item.image}
                                  style={convertLineStyleData(
                                    'border: ' +
                                    (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                                  )}
                                />
                                {index == 0 && (
                                  <div className="leader-logo">团长</div>
                                )}
                              </div>
                            )
                          })}
                        </div>
                        <div className="btn-wrap">
                          <div
                            className="open-new isRelative"
                            onClick={this.openNewGroup}
                          >
                            开启新团
                          </div>
                        </div>
                      </div>
                    )}
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    {(myTeams && myTeams.current_status == 2) && (
                      <div className="success-draw">
                        <div className="tip">
                          <div>
                            抽奖结果将于
                          <div className="countDown">
                              {(myTeams.downCount.days != '00' ||
                                myTeams.downCount.days != '0') && (
                                  <React.Fragment>
                                    <span>{myTeams.downCount.days}</span>
                                    <span>天</span>
                                  </React.Fragment>
                                )}
                              <span>{myTeams.downCount.hours}</span>
                              <span>:</span>
                              <span style={convertLineStyleData('width:48rpx;')}>
                                {myTeams.downCount.minutes}
                              </span>
                              <span>:</span>
                              <span style={convertLineStyleData('width:48rpx;')}>
                                {myTeams.downCount.seconds}
                              </span>
                            </div>
                            后揭晓
                        </div>
                        </div>
                        <div className="member-cover">
                          <div>
                            <img
                              src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/question-mask.png"
                            />
                          </div>
                        </div>
                        <div className="btn-wrap">
                          <div
                            className="open-new isRelative"
                            onClick={this.inviteFriends}
                          >
                            邀请好友
                          </div>
                          <div
                            className="show-own isRelative"
                            onClick={this.showMyTeam}
                          >
                            查看我的拼团
                          <form className="getFormId">
                              <button
                                type="button"
                                onClick ={this.formSubmit_collect}
                                data-id={goodsInfo && goodsInfo.id}
                                data-orderid={goodsInfo && goodsInfo.order_id}
                                data-bargainid={goodsInfo && goodsInfo.bargain_id}
                                className="invisibleclass"
                              ></button>
                            </form>
                          </div>
                        </div>
                      </div>
                    )}
                    {myTeams && myTeams.current_status == 3 && myTeams.is_winner == 1 && (
                      <div className="success-draw">
                        <div className="tip">
                          <div>
                            运气爆棚！<span style={convertLineStyleData('color:#ff7100;')}>中奖啦</span>～
                        </div>
                        </div>
                        <div className="member-cover">
                          <div>
                            <img
                              src={myTeams.winner}
                              style={convertLineStyleData('border: 2rpx solid #ff7100;')}
                            />
                          </div>
                        </div>
                        <div className="btn-wrap">
                          <div
                            className="open-new isRelative"
                            onClick={this.goToGroupDetail}
                          >
                            查看我的拼团
                          </div>
                        </div>
                      </div>
                    )}
                    {myTeams && (myTeams.current_status == 4 ||
                      myTeams.current_status == 5 ||
                      myTeams.is_winner == 0) && (
                        <div className="loading-draw">
                          <div className="tip">
                            {myTeams.is_winner == 0 ? (
                              <React.Fragment>很遗憾，您未中奖</React.Fragment>
                            ) : (
                                <React.Fragment>很遗憾，本次活动未达到开奖门槛</React.Fragment>
                              )}
                          </div>
                          <div
                            className="member-cover"
                            style={convertLineStyleData('margin-bottom:50rpx;width:165rpx;height:165rpx;')}
                          >
                            <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/draw-fail.png" />
                          </div>
                        </div>
                      )}
                  </React.Fragment>
                )}
            </div>
          </div>
          <div className="collage-section">
            {status == 1 && (
              <div className="collect-benefit-area">
                <div className="activity-box">
                  <div className="line"></div>
                  <div className="activity-title">活动</div>
                  <div className="line"></div>
                </div>
                <div className="collect-item">
                  <div className="star-num">
                    {'集集乐个数: ' + collectBenefitData.star_num}
                  </div>
                  <div className="star-list">
                    {starData.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item == 'light' ? (
                            <img
                              className="star-item"
                              src={collectBenefitData.light_img}
                            />
                          ) : (
                              item == 'dark' && (
                                <img
                                  className="star-item"
                                  src={collectBenefitData.dark_img}
                                />
                              )
                            )}
                        </React.Fragment>
                      )
                    })}
                  </div>
                  {collectBenefitData.star_num ==
                    collectBenefitData.collect_num && (
                      <div className="star-full">
                        <div className="star-full-text">满</div>
                      </div>
                    )}
                </div>
                <div className="tip-item">
                  {collectBenefitData.star_num ==
                    collectBenefitData.collect_num ? (
                      <div>{'获得一张' + collectBenefitData.coupon_title}</div>
                    ) : (
                      collectBenefitData.star_num !=
                      collectBenefitData.collect_num && (
                        <div>
                          {'消费' +
                            (collectBenefitData.play_type == 0
                              ? '每满'
                              : '超过') +
                            collectBenefitData.value +
                            '元，累计一颗星，集满可获得' +
                            collectBenefitData.coupon_title +
                            '一张'}
                        </div>
                      )
                    )}
                </div>
              </div>
            )}
            {/*  刮刮乐  */}
            <div className="scratchWhole" hidden={isWhole}>
              <div className="activity-box scratch-activity">
                <div className="line"></div>
                <div className="activity-title">活动</div>
                <div className="line"></div>
              </div>
              <div className="scratchArea">
                <div className="scratchFail" hidden={isFail}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png" />
                  <div className="failTitle">
                    <div className="failShare" onClick={this.shareClickEvent}>分享</div>
                    <div className="failText">很遗憾没有中奖哦</div>
                  </div>
                </div>
                {/*  中奖  */}
                <div className="scratchWinning" hidden={isWinning}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png" />
                  <div className="winningTitle">
                    <div className="winningShare" onClick={this.shareClickEvent}>分享</div>
                    <div className="winningText">恭喜你获得了</div>
                    <div className="winningText winningValue">
                      {winingTitle}
                    </div>
                  </div>
                </div>
                {/*  安慰奖  */}
                <div className="scratchComfort" hidden={isComfort}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png" />
                  <div className="comfortTitle">
                    <div className="comfortShare" onClick={this.shareClickEvent}>分享</div>
                    {ifGetComfort ? (
                      <div className="comfortText">
                        已领取，在微信卡包中查看哦~
                      </div>
                    ) : (
                        <div className="comfortText" className="comfortText">
                          又没中奖，送你一个小礼品
                      </div>
                      )}
                    {!ifWxCoupon && !ifGetComfort && (
                      <div className="comfortText">
                        >在优惠券卡包进行查收哦~
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="scratch_wp"
                  hidden={hideCanvas}
                  style={convertLineStyleData(
                    'width: ' +
                    (scratch && scratch.width) +
                    'px; height: ' +
                    (scratch && scratch.height) +
                    'px;'
                  )}
                >
                  <canvas
                    className="scratch-canvas"
                    width={scratch && scratch.width}
                    height={scratch && scratch.height}
                    id="scratch-canvas"
                    onTouchStart={this.touchStart}
                    onTouchMove={this.touchMove}
                    onTouchEnd={this.touchEnd}
                  ></canvas>
                  {isShowteam && (
                    <div className="showArea">
                      <div className="showTitle">赢取优惠大奖</div>
                      <div className="showBtn" onClick={this.showAreaClick}>
                        点我刮奖
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isShowVipCardDialog && (
              <div
                className="vipCard-dialog"
                onClick={this.closeVipCardDialog}
                data-type="shadow"
              >
                {!ifUserInfo && (
                  <div className="content">
                    <div
                      className="top-block"
                      style={convertLineStyleData('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-dialog-head2.png);')}
                    >
                      <span className="text">请填写会员信息</span>
                    </div>
                    <div className="vip-info">
                      {userInfoCollectConfig.collect_username == 1 && (
                        <div className="info-item">
                          <div className="item-name">姓名</div>
                          <div className="item-right">
                            <input
                              type="text"
                              placeholder="请填写姓名"
                              maxlength="10"
                              value={userInfo.nickname}
                              data-type="name"
                              onInput={this.inputUserInfo}
                            />
                          </div>
                        </div>
                      )}
                      {userInfoCollectConfig.collect_phone == 1 && (
                        <div className="info-item">
                          <div className="item-name">电话</div>
                          <div className="item-right">
                            <input
                              type="number"
                              disabled="true"
                              placeholder="请授权手机号码"
                              value={userInfo.phone}
                              data-type="phone"
                              onInput={this.inputUserInfo}
                            />
                            {isGetPhoneNumber && (
                              <button
                                className="get-authorize"
                                style={convertLineStyleData('background-color: #D2D2D2')}
                              >
                                已授权
                              </button>
                            )}
                            {!isGetPhoneNumber && (
                              <button
                                className="get-authorize"
                                style={convertLineStyleData('background-color: #FF7100')}
                                onGetphonenumber={this.getPhoneNumber}
                              >
                                获得授权
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                      {userInfoCollectConfig.collect_birthday == 1 && (
                        <div className="info-item">
                          <div className="item-name">生日</div>
                          <div className="item-right">
                            <Picker
                              mode="date"
                              value={userInfo.birthday}
                              start="1900-01-01"
                              end={todayDate}
                              onChange={this.bindBirthdayChange}
                            >
                              <div
                                className="picker"
                                style={convertLineStyleData(
                                  'color: ' +
                                  (userInfo.birthday === '' ? '#999' : '#000')
                                )}
                              >
                                {userInfo.birthday === ''
                                  ? '请选择生日信息'
                                  : userInfo.birthday}
                              </div>
                            </Picker>
                            <div className="ico-moon icon-rightarrow"></div>
                          </div>
                        </div>
                      )}
                      {userInfoCollectConfig.collect_region == 1 && (
                        <div className="info-item">
                          <div className="item-name">城市</div>
                          <div className="item-right">
                            <Picker
                              mode="region"
                              onChange={this.bindCityChange}
                              value={userCityArr}
                            >
                              <div
                                className="picker"
                                style={convertLineStyleData(
                                  'color: ' +
                                  (userCityArr[0] === '' ? '#999' : '#000')
                                )}
                              >
                                {userCityArr[0] === ''
                                  ? '请填写所在城市'
                                  : userCityArr[0] +
                                  userCityArr[1] +
                                  userCityArr[2]}
                              </div>
                            </Picker>
                            <div className="ico-moon icon-rightarrow"></div>
                          </div>
                        </div>
                      )}
                      <div className="save-btn" onClick={this.saveUserInfo}>
                        立即领取
                      </div>
                    </div>
                    <div
                      className="ico-moon icon-closed"
                      data-type="shadow"
                    ></div>
                  </div>
                )}
                {ifUserInfo && (
                  <div className="content">
                    <div
                      className="top-block"
                      style={convertLineStyleData('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-dialog-head.png);')}
                    >
                      <div className="text-block">
                        <div className="success-text">注册会员成功</div>
                        <div className="success-text">恭喜获得以下权益</div>
                      </div>
                    </div>
                    <div className="interests-block">
                      {vipCardInfo.discount && (
                        <div className="interests-item">
                          <img
                            className="icon"
                            src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/discount-icon.svg"
                          />
                          <div className="count">
                            {vipCardInfo.discount + '折'}
                          </div>
                          <div className="text">会员折扣</div>
                        </div>
                      )}
                      {vipCardInfo.coupon_list &&
                        vipCardInfo.coupon_list.length && (
                          <div className="interests-item">
                            <img
                              className="icon"
                              src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/coupon-icon.svg"
                            />
                            <div className="count">
                              {vipCardInfo.coupon_list.length + '张'}
                            </div>
                            <div className="text">会员赠送</div>
                          </div>
                        )}
                      {vipCardInfo.integral && vipCardInfo.integral != 0 && (
                        <div className="interests-item">
                          <img
                            className="icon"
                            src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/integral-icon.svg"
                          />
                          <div className="count">
                            {vipCardInfo.integral + '+'}
                          </div>
                          <div className="text">积分赠送</div>
                        </div>
                      )}
                    </div>
                    <div
                      className="ico-moon icon-closed"
                      data-type="shadow"
                    ></div>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* TODO <ComponentPayfinishgift
            orderId={orderId}
            franchisee={franchisee}
          ></ComponentPayfinishgift> */}
          {goodsData.goods_list.length > 0 && (
            <div className="collage-section collage-more">
              <div className="collage-section title">更多精彩拼团</div>
              <div>
                <div className="goods-list opposite">
                  {goodsData.goods_list.map((item, index) => {
                    return (
                      <div
                        className="goods-item isRelative"
                        key={item.goods_id}
                        data-goodsid={item.goods_id}
                        data-activityid={item.activity_id}
                        onClick={this.gotoDetail}
                      >
                        <div className="image-wrap">
                          <img src={item.cover} />
                        </div>
                        <div className="content-wrap">
                          <div className="title">
                            <div className="classify-type">
                              <div>
                                <i className="ico-moon icon-number-people"></i>
                              </div>
                              <span>
                                {item.activity_type == 0
                                  ? item.num_of_people.length > 1
                                    ? '多人团'
                                    : item.num_of_people[0] + '人团'
                                  : item.activity_type == 1
                                    ? '新人团'
                                    : item.activity_type == 2
                                      ? '阶梯团'
                                      : item.activity_type == 3
                                        ? '帮帮团'
                                        : '抽奖团'}
                              </span>
                            </div>
                            {item.title}
                          </div>
                          {item.salesnum ? (
                            <div className="hava-sales">
                              <div className="price">
                                <span className="min-price">
                                  ¥<span>{item.group_buy_price}</span>
                                </span>
                                <span className="origin-price">
                                  {'¥' + item.original_price}
                                </span>
                              </div>
                              <div className="status">
                                <div className="sales">
                                  {'已团' + item.salesnum + '件'}
                                </div>
                                <div className="to-join">
                                  {item.status == 0 ? (
                                    <React.Fragment>
                                      <button className="ready">
                                        即将开团
                                      </button>
                                    </React.Fragment>
                                  ) : item.status == 1 ? (
                                    <React.Fragment>
                                      <button className="remain">提醒我</button>
                                    </React.Fragment>
                                  ) : item.status == 2 ? (
                                    <React.Fragment>
                                      <button className="reminded">
                                        已提醒
                                      </button>
                                    </React.Fragment>
                                  ) : item.status == 3 ? (
                                    <React.Fragment>
                                      <button className="go">去拼团</button>
                                    </React.Fragment>
                                  ) : (
                                            item.status == 4 && (
                                              <React.Fragment>
                                                <button className="over">已结束</button>
                                              </React.Fragment>
                                            )
                                          )}
                                </div>
                              </div>
                            </div>
                          ) : (
                              <div className="no-sales">
                                <div className="price">
                                  <div className="min-price">
                                    ¥<span>{item.group_buy_price}</span>
                                  </div>
                                  <div className="origin-price">
                                    {'¥' + item.original_price}
                                  </div>
                                </div>
                                <div className="to-join">
                                  {item.status == 0 ? (
                                    <React.Fragment>
                                      <button className="ready">即将开团</button>
                                    </React.Fragment>
                                  ) : item.status == 1 ? (
                                    <React.Fragment>
                                      <button className="remain">提醒我</button>
                                    </React.Fragment>
                                  ) : item.status == 2 ? (
                                    <React.Fragment>
                                      <button className="reminded">已提醒</button>
                                    </React.Fragment>
                                  ) : item.status == 3 ? (
                                    <React.Fragment>
                                      <button className="go">去拼团</button>
                                    </React.Fragment>
                                  ) : (
                                            item.status == 4 && (
                                              <React.Fragment>
                                                <button className="over">已结束</button>
                                              </React.Fragment>
                                            )
                                          )}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/gp-pay-success/GpPaySuccess.jsx